<template>
  <van-dialog v-model="showInner" :title="poster.title"
              :show-cancel-button="false"
              close-on-click-overlay
              :show-confirm-button="!!poster.confirmButtonText"
              :confirm-button-text="$tt(poster.confirmButtonText)"
              :showCancelButton="!!poster.cancelButtonText"
              :cancelButtonText="$tt(poster.cancelButtonText)"
              :before-close="close"
              :style="poster.parentStyle"
              :theme="poster.parentStyle?'round-button':null"
              allow-html
              cancelButtonColor="#cccccc"
  >
    <div class="pa-2 rich-text" v-html="getFileViewContent(poster.content)"></div>
  </van-dialog>
</template>

<script>

export default {
  name: "zposterdialog",
  components: {},
  props: {
    show: {},
    posterCode: {},
  },
  data() {
    return {
      showInner: false,
      poster: {},
    }
  },
  watch: {
    showInner(val) {
      this.$emit('update:show', val)
    },
  },
  async created() {
    this.poster = await this.getPoster(this.posterCode)
    if (this.poster) {
      this.showInner = true
    } else {
      this.$emit('posterNoConfig')
    }
  },
  methods: {
    close(action, done) {
      if (action === 'overlay') {
        done()
      } else if (action === 'confirm') {
        let url = this.poster.confirmButtonUrl
        if (url) {
          if (url.indexOf('http') === 0) {
            window.open(url)
          } else {
            // this.jump(customerUrl)
            this.$router.push({path: url})
          }
        }
        done(true)
      } else if (action === 'cancel') {
        let url = this.poster.cancelButtonUrl
        if (url) {
          if (url.indexOf('http') === 0) {
            window.open(url)
          } else {
            this.$router.push({path: url})
          }
        }
        done(true)
      }
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep {
  .van-dialog__header {
    padding: 8px;
  }

  .van-dialog__footer {
    border-radius: 16px;
    padding: 16px !important;
  }
}
</style>
